// CartSummary component for mobile sticky header
import React from 'react';
import { useCartStore } from '../store/cartStore';
import { useMinimumOrder } from '../hooks';
import { TEMPORARY_CLOSURE_ENABLED } from '../shared/temporaryClosure';
import './CartSummary.css';

interface CartSummaryProps {
    onGoToCart: () => void;
}

const CartSummary: React.FC<CartSummaryProps> = ({ onGoToCart }) => {
    const { cart } = useCartStore();
    const { meetsMinimum, minimumText, hasItems } = useMinimumOrder();
    const discount = cart.discount;
    const discountActive = !!discount && cart.totals.discountAmount > 0;

    if (!hasItems || TEMPORARY_CLOSURE_ENABLED) {
        return null;
    }

    return (
        <div className="cart-summary">
            <div className="cart-summary-content">
                <div className="cart-summary-info">
                    <span className="cart-summary-icon">🛒</span>
                    <div className="cart-summary-details">
                        <span className="cart-summary-items">
                            {cart.items.length} item{cart.items.length !== 1 ? 's' : ''}
                        </span>
                        <span className="cart-summary-total">
                            £{cart.totals.total.toFixed(2)}
                        </span>
                        {discountActive && (
                            <span className="cart-summary-discount">
                                Saved £{cart.totals.discountAmount.toFixed(2)}
                            </span>
                        )}
                    </div>
                </div>
                {meetsMinimum ? (
                    <button
                        className="go-to-cart-btn"
                        onClick={onGoToCart}
                    >
                        Go to Basket
                    </button>
                ) : (
                    <div className="minimum-warning-mobile">
                        <span className="warning-icon-mobile">ℹ️</span>
                        <span className="warning-text-mobile">Min {minimumText}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CartSummary;
